import styled from 'styled-components';

import { getBodyFontWeight, getTypographyFontColor } from './helpers';
import { FontColor } from './types';

export interface BodyProps {
    bold?: boolean;
    color?: FontColor;
    light?: boolean;
    medium?: boolean;
}

const Body01 = styled.p<BodyProps>`
    font-family: ${ ({ theme }) => theme.type.regularFont };
    font-weight: ${ getBodyFontWeight };    
    color: ${ getTypographyFontColor };
    font-size: 1rem;
    letter-spacing: 0;
    line-height: 24px;
    margin: 0;
    padding: 0;
`;

export default Body01;
